import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function maxArrayLength(max = 50): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const { value } = control;

    if (value.length <= max) return null;

    return { maxLength: true };
  };
}
